import config from '../../variables/config'

const types_redhill = [
  {
    name: 'Zebra Bronze party',
    packages: [
      '2 hours of fun, play and food (Lunch Box and unlimited drinks)',
      'Party Room Theme can be chosen for extra, no host',
      'Tableware not included, basic party bag not included, cake can be chosen for extra',
      'One FREE admission of one adult per child',
      'Young Sibling for £9.75',
      'downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    offPrice: 975,
    peakPrice: 1425,
    siblingPrice: 975
  },
  {
    name: 'Leopard Silver Party',
    packages: [
      '2 hours of fun, play and food (Hot Food and unlimited drinks)',
      'Party Room Theme can be chosen for extra, no host',
      'Tableware included, cake & basic party bag can be chosen for extra',
      'One FREE admission of one adult per child',
      'Young Sibling for £15',
      'FREE downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    offPrice: 1675,
    peakPrice: 2025,
    siblingPrice: 1675
  },
  {
    name: 'Lion Gold Party',
    packages: [
      '80 mins of soft play and 40 mins food',
      'Mascot of your choice to bring out the birthday cake, sing the birthday song',
      'Food includes hot food buffet and unlimited squash drinks',
      'Tableware, balloon tree (balloons on a stand) and party bags upgrade included',
      'Two FREE admission of adult per child',
      'FREE 1 jug of tea and 1 jug of coffee for adults'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    offPrice: 2575,
    peakPrice: 3025,
    siblingPrice: 2575
  },
  {
    name: 'Make A Bear',
    packages: [
      '2 hours of Make a bear, play and food (Lunch Box and unlimited drinks)',
      'Party Room Theme can be chosen for extra',
      'Tableware, basic party bag included, cake can be chosen for extra',
      'One FREE admission of one adult per child',
      'Young Sibling for £19.75',
      'downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    offPrice: 1975,
    peakPrice: 2495,
    siblingPrice: 1975
  },
  {
    name: 'Castle Bronze Party',
    packages: [
      '2 hours of fun, play and food (Lunch Box and unlimited drinks)',
      'Party Room Theme can be chosen for extra',
      'Tableware included, basic party bag not included, cake can be chosen for extra',
      'One FREE admission of one adult per child',
      'Birthday Child Sibling for £9.75',
      'downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    offPrice: 975,
    peakPrice: 1425,
    siblingPrice: 975
  },
  {
    name: 'Dragon Silver Party',
    packages: [
      '2 hours of fun, play and food (Hot Food and unlimited drinks)',
      'Party Room Theme can be chosen for extra',
      'Tableware included, party bag & cake can be chosen for extra',
      'One FREE admission of one adult per child',
      'Young Sibling for £15',
      'FREE downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    offPrice: 1575,
    peakPrice: 1875,
    siblingPrice: 1575
  },
  {
    name: 'Knight Gold Party',
    packages: [
      '80 mins of soft play and 40 mins food',
      'Mascot of your choice to bring out the birthday cake, sing the birthday song',
      'Food includes hot food buffet and unlimited squash drinks',
      'Tableware, balloon tree (balloons on a stand) and party bags upgrade included',
      'Two FREE admission of adult per child',
      'FREE 1 jug of tea and 1 jug of coffee for adults'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    offPrice: 2575,
    peakPrice: 2975,
    siblingPrice: 2575
  },
  {
    name: 'Platinum Party - Zebra',
    aftername: 'For Up To 50 Kids!',
    subtitle:
      'For up to 50 kids - massive discounts available for large parties, school fundraisers and charity events',
    packages: [
      '20 guests in the package',
      '£2.75 for extra lunch box',
      'Our staff host the party',
      '2 hours of fun, play and food (Lunch Box and unlimited drinks)',
      'Party Room Theme can be chosen for extra',
      'Tableware included, extra cake can be chosen for an extra £40',
      'FREE admission of adults',
      'FREE downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    numberOfChildren: 25,
    extraPrice: 300,
    offPackagePrice: 48800,
    peakPackagePrice: 74900
  },
  {
    name: 'Platinum Party - Leopard',
    aftername: 'For Up To 50 Kids!',
    subtitle:
      'For up to 50 kids - massive discounts available for large parties, school fundraisers and charity events',
    packages: [
      '20 guests in the package',
      'extra £2.50 for upgrade lunchbox to hot food',
      '£5.00 for extra child hot food',
      'Our staff host the party',
      '2 hours of fun, play and food (Lunch Box and unlimited drinks)',
      'Party Room Theme can be chosen for extra',
      'Tableware included, extra cake can be chosen for an extra £40',
      'FREE admission of adults',
      'FREE downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    numberOfChildren: 20,
    extraPrice: 550,
    offPackagePrice: 48800,
    peakPackagePrice: 74900
  }
]

const types_kingston = [
  {
    name: 'Zebra Bronze party',
    packages: [
      '2 hours of fun, play and food (Lunch Box and unlimited drinks)',
      'Party Room Theme can be chosen for extra, no host',
      'Tableware, balloon, basic party bag not included, cake can be chosen for extra',
      'One FREE admission of one adult per child',
      'Young Sibling for £9.5',
      'downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    offPrice: 1175,
    peakPrice: 1725,
    siblingPrice: 1275
  },
  {
    name: 'Leopard Silver Party',
    packages: [
      '2 hours of fun, play and food (Hot Food and unlimited drinks)',
      'Party Room Theme can be chosen for extra, no host',
      'Tableware included, balloon, basic party bag not included, cake can be chosen for extra',
      'One FREE admission of one adult per child',
      'Young Sibling for £15',
      'FREE downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    offPrice: 1675,
    peakPrice: 2175,
    siblingPrice: 1675
  },
  {
    name: 'Lion Gold Party',
    packages: [
      '80 mins of soft play and 40 mins food & party room/area',
      'Mascot of your choice to bring out the birthday cake, sing the birthday song',
      'Food includes hot food buffet and unlimited squash drinks',
      'Tableware, balloon tree (balloons on a stand) and party bags upgrade included',
      'Two FREE admission of adult per child',
      'FREE 1 jug of tea and 1 jug of coffee for adults',
      'If capacity allows you will be allocated into a party room'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    offPrice: 2575,
    peakPrice: 3075,
    siblingPrice: 2575
  },
  {
    name: 'Make A Bear',
    packages: [
      '2 hours of Make a bear, play and food (Lunch Box and unlimited drinks)',
      'Party Room Theme can be chosen for extra',
      'Tableware, balloon, basic party bag included, cake can be chosen for extra',
      'One FREE admission of one adult per child',
      'Young Sibling for £22.95',
      'downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    offPrice: 2495,
    peakPrice: 2895,
    siblingPrice: 2495
  },
  {
    name: 'Castle Bronze Party',
    packages: [
      '2 hours of fun, play and food (Lunch Box and unlimited drinks)',
      'Party Room Theme can be chosen for extra',
      'Tableware, basic party bag included, cake can be chosen for extra',
      'One FREE admission of one adult per child',
      'Young Sibling for £10.75',
      'downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    offPrice: 1350,
    peakPrice: 1895,
    siblingPrice: 1350
  },
  {
    name: 'Dragon Silver Party',
    packages: [
      '2 hours of fun, play and food (Hot Food and unlimited drinks)',
      'Party Room Theme can be chosen for extra',
      'Tableware and basic party bag included, cake can be chosen for extra',
      'One FREE admission of one adult per child',
      'Young Sibling for £16.75',
      'FREE downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    offPrice: 1850,
    peakPrice: 2395,
    siblingPrice: 1850
  },
  {
    name: 'Knight Gold Party',
    packages: [
      'Our staff host the party with entertainments',
      '2 hours of fun, play and food (Hot Food and unlimited drinks)',
      'Party Room Theme can be chosen for extra',
      'Tableware, balloon, party bag included, extra cake can be chosen for an extra £40',
      'One FREE admission of adult per child',
      'FREE downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    offPrice: 2795,
    peakPrice: 3395,
    siblingPrice: 2795
  },
  {
    name: 'Platinum Party - Zebra',
    aftername: 'For Up To 50 Kids!',
    subtitle:
      'For up to 50 kids - massive discounts available for large parties, school fundraisers and charity events',
    packages: [
      '20 guests in the package',
      '£2.75 for extra lunch box',
      'Our staff host the party',
      '2 hours of fun, play and food (Lunch Box and unlimited drinks)',
      'Party Room Theme can be chosen for extra',
      'Basic Tableware included, extra cake can be chosen for an extra £40',
      'FREE admission of adults',
      'FREE downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    numberOfChildren: 25,
    extraPrice: 300,
    offPackagePrice: 48800,
    peakPackagePrice: 74900
  },
  {
    name: 'Platinum Party - Zebra Sat',
    aftername: 'For Up To 50 Kids!',
    subtitle:
      'For up to 50 kids - massive discounts available for large parties, school fundraisers and charity events',
    packages: [
      '20 guests in the package',
      '£2.75 for extra lunch box',
      'Our staff host the party',
      '2 hours of fun, play and food (Lunch Box and unlimited drinks)',
      'Party Room Theme can be chosen for extra',
      'Basic Tableware included, extra cake can be chosen for an extra £40',
      'FREE admission of adults',
      'FREE downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    numberOfChildren: 25,
    extraPrice: 300,
    offPackagePrice: 48800,
    peakPackagePrice: 84900
  },
  {
    name: 'Platinum Party - Leopard',
    aftername: 'For Up To 40 Kids!',
    subtitle:
      'For up to 50 kids - massive discounts available for large parties, school fundraisers and charity events',
    packages: [
      '20 guests in the package',
      'extra £2.50 for upgrade lunchbox to hot food',
      '£5.00 for extra child hot food',
      'Our staff host the party',
      '2 hours of fun, play and food (Lunch Box and unlimited drinks)',
      'Party Room Theme can be chosen for extra',
      'Basic Tableware included, extra cake can be chosen for an extra £40',
      'Two FREE admission of adult per child',
      'FREE downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    numberOfChildren: 20,
    extraPrice: 550,
    offPackagePrice: 48800,
    peakPackagePrice: 74900
  },
  {
    name: 'Platinum Party - Leopard Sat',
    aftername: 'For Up To 40 Kids!',
    subtitle:
      'For up to 50 kids - massive discounts available for large parties, school fundraisers and charity events',
    packages: [
      '20 guests in the package',
      'extra £2.50 for upgrade lunchbox to hot food',
      '£5.00 for extra child hot food',
      'Our staff host the party',
      '2 hours of fun, play and food (Lunch Box and unlimited drinks)',
      'Party Room Theme can be chosen for extra',
      'Basic Tableware included, extra cake can be chosen for an extra £40',
      'Two FREE admission of adult per child',
      'FREE downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    numberOfChildren: 20,
    extraPrice: 550,
    offPackagePrice: 48800,
    peakPackagePrice: 84900
  }
]

const types_southampton = [
  {
    name: 'Zebra Bronze party',
    packages: [
      '2 hours of fun, play and food (Lunch Box and unlimited drinks)',
      'Party Room Theme can be chosen for extra, no host',
      'Tableware not included, basic party bag not included, cake can be chosen for extra',
      'One FREE admission of one adult per child',
      'Young Sibling for £9.75',
      'downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    offPrice: 975,
    peakPrice: 1425,
    siblingPrice: 975
  },
  {
    name: 'Leopard Silver Party',
    packages: [
      '2 hours of fun, play and food (Hot Food and unlimited drinks)',
      'Party Room Theme can be chosen for extra, no host',
      'Tableware included, cake & basic party bag can be chosen for extra',
      'One FREE admission of one adult per child',
      'Young Sibling for £15',
      'FREE downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    offPrice: 1675,
    peakPrice: 2025,
    siblingPrice: 1675
  },
  {
    name: 'Lion Gold Party',
    packages: [
      '80 mins of soft play and 40 mins food',
      'Mascot of your choice to bring out the birthday cake, sing the birthday song',
      'Food includes hot food buffet and unlimited squash drinks',
      'Tableware, balloon tree (balloons on a stand) and party bags upgrade included',
      'Two FREE admission of adult per child',
      'FREE 1 jug of tea and 1 jug of coffee for adults'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    offPrice: 2575,
    peakPrice: 3025,
    siblingPrice: 2575
  },
  {
    name: 'Make A Bear',
    packages: [
      '2 hours of Make a bear, play and food (Lunch Box and unlimited drinks)',
      'Party Room Theme can be chosen for extra',
      'Tableware, basic party bag included, cake can be chosen for extra',
      'One FREE admission of one adult per child',
      'Young Sibling for £19.75',
      'downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    offPrice: 1975,
    peakPrice: 2495,
    siblingPrice: 1975
  },
  {
    name: 'Castle Bronze Party',
    packages: [
      '2 hours of fun, play and food (Lunch Box and unlimited drinks)',
      'Party Room Theme can be chosen for extra',
      'Tableware included, basic party bag not included, cake can be chosen for extra',
      'One FREE admission of one adult per child',
      'Birthday Child Sibling for £9.75',
      'downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    offPrice: 975,
    peakPrice: 1425,
    siblingPrice: 975
  },
  {
    name: 'Dragon Silver Party',
    packages: [
      '2 hours of fun, play and food (Hot Food and unlimited drinks)',
      'Party Room Theme can be chosen for extra',
      'Tableware included, party bag & cake can be chosen for extra',
      'One FREE admission of one adult per child',
      'Young Sibling for £15',
      'FREE downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    offPrice: 1575,
    peakPrice: 1875,
    siblingPrice: 1575
  },
  {
    name: 'Knight Gold Party',
    packages: [
      '80 mins of soft play and 40 mins food',
      'Mascot of your choice to bring out the birthday cake, sing the birthday song',
      'Food includes hot food buffet and unlimited squash drinks',
      'Tableware, balloon tree (balloons on a stand) and party bags upgrade included',
      'Two FREE admission of adult per child',
      'FREE 1 jug of tea and 1 jug of coffee for adults'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    offPrice: 2575,
    peakPrice: 2975,
    siblingPrice: 2575
  },
  {
    name: 'Platinum Party - Zebra',
    aftername: 'For Up To 50 Kids!',
    subtitle:
      'For up to 50 kids - massive discounts available for large parties, school fundraisers and charity events',
    packages: [
      '20 guests in the package',
      '£2.75 for extra lunch box',
      'Our staff host the party',
      '2 hours of fun, play and food (Lunch Box and unlimited drinks)',
      'Party Room Theme can be chosen for extra',
      'Tableware included, extra cake can be chosen for an extra £40',
      'FREE admission of adults',
      'FREE downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    numberOfChildren: 25,
    extraPrice: 300,
    offPackagePrice: 48800,
    peakPackagePrice: 74900
  },
  {
    name: 'Platinum Party - Leopard',
    aftername: 'For Up To 50 Kids!',
    subtitle:
      'For up to 50 kids - massive discounts available for large parties, school fundraisers and charity events',
    packages: [
      '20 guests in the package',
      'extra £2.50 for upgrade lunchbox to hot food',
      '£5.00 for extra child hot food',
      'Our staff host the party',
      '2 hours of fun, play and food (Lunch Box and unlimited drinks)',
      'Party Room Theme can be chosen for extra',
      'Tableware included, extra cake can be chosen for an extra £40',
      'FREE admission of adults',
      'FREE downloadable invites'
    ],
    extra: {
      description:
        'We also have a variety of options to choose from including a range of different party bags and additional extras, such as food for grown-ups'
    },
    numberOfChildren: 20,
    extraPrice: 550,
    offPackagePrice: 48800,
    peakPackagePrice: 74900
  }
]

const whichParties = location => {
  switch (location) {
    case 'Redhill':
      return types_redhill
    case 'Kingston':
      return types_kingston
    case 'Southampton':
      return types_southampton
    default:
      //Should never get here
      return types_redhill
  }
}

export const types = whichParties(config.branch)

export default types
